<div class="overflow-y-hidden mx-1">
    <div class="bg-white rounded-xl py-4 mb-4 pl-4">
        @if (isLoading()) {
            <app-loading
                class="m-auto"
                size="30" />
        } @else {
            <div class="flex justify-between items-center">
                <app-main-title
                    iconColor="text-custom-blue"
                    iconSize="xl"
                    titleSize="text-2xl"
                    [icon]="['far', 'arrow-left']"
                    [isIconAction]="true"
                    [title]="'formAnswers' | transloco"
                    (actionClicked)="goBack()" />

                <app-select
                    placeholder="formName"
                    [canClear]="false"
                    [defaultValue]="selectedForm() ? [{ label: selectedForm()!.name, value: selectedForm()!.id }] : []"
                    [options]="formOptions()"
                    (optionSelected)="changeForm($event)" />
            </div>

            @if (isNotApplicableForm()) {
                <div class="pl-4 flex flex-row justify-end">
                    <p class="!m-0 pt-2 pr-2 text-gray-300 text-caption">
                        {{ 'pleaseNoteFormIsNotApplicable' | transloco }}
                    </p>
                </div>
            }
        }
    </div>

    <app-field-intervention-form-category [currentForm]="selectedForm()" />
</div>
